var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconWaterfowl = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.94 4.112c-.399.355-1.033.819-1.576 1.156l-.208.128c-.22.138-.9.511-1.304.714-1.578.795-3.2 1.44-5.724 2.273a116.6 116.6 0 0 1-2.4.772c-2.008.626-2.602.816-3.281 1.052-1.752.605-2.69 1.078-2.989 1.505-.27.388-.456 1.007-.458 1.521 0 .32.089.81.221 1.208.152.462.322.844.839 1.877.637 1.277.704 1.46.704 1.929-.002.313-.03.45-.15.708-.22.467-.64.864-1.248 1.18l-.198.104.028.045c.64 1.018 1.25 1.654 1.639 1.712.183.027.338-.078.456-.308a.787.787 0 0 1 .39-.371c.355-.176.722-.254 2.028-.426 1.195-.156 1.641-.232 2.2-.375 1.518-.386 2.41-1.052 2.755-2.066.022-.067.04-.122.037-.122l-.167.055a7.06 7.06 0 0 1-1.348.3 7.71 7.71 0 0 1-1.24.011c-.33-.04-.362-.054-.212-.09a30.819 30.819 0 0 0 2.766-.79c3.28-1.105 5.163-2.409 5.453-3.77.033-.157.044-.595.015-.624-.01-.01-.077.029-.162.094a13 13 0 0 1-3.693 1.963c-.963.328-2.13.57-2.881.596l-.236.01.303-.09c2.718-.802 4.944-1.892 6.419-3.144.213-.183.65-.614.813-.806.59-.697.945-1.405 1.081-2.155.04-.232.063-.819.038-1.003l-.014-.107-.11.134c-.22.275-.637.661-1.037.96-1.152.866-2.934 1.69-5.102 2.363-1.027.32-2.311.65-3.186.823-.282.056-.39.065-.204.018.37-.093 1.736-.553 2.52-.848 1.636-.616 3.24-1.39 4.483-2.164 2.77-1.724 4.177-3.662 4.104-5.655a2.869 2.869 0 0 0-.025-.358L22.066 4l-.126.112z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWaterfowl, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-waterfowl.dc168d0f.svg";
export { ForwardRef as ReactComponent };